import { createContext, ReactNode, useContext, useState } from "react";

interface WorkflowContextType {
  workflowName: string;
  setWorkflowName: (name: string) => void;
  isDirty: boolean;
  setIsDirty: (dirty: boolean) => void;
}

const WorkflowContext = createContext<WorkflowContextType | undefined>(undefined);

interface WorkflowProviderProps {
  children: ReactNode;
}

export const WorkflowProvider = ({ children }: WorkflowProviderProps) => {
  const [workflowName, setWorkflowName] = useState("Untitled Workflow");
  const [isDirty, setIsDirty] = useState(false);

  return (
    <WorkflowContext.Provider value={{ workflowName, setWorkflowName, isDirty, setIsDirty }}>
      {children}
    </WorkflowContext.Provider>
  );
};

export const useWorkflow = () => {
  const context = useContext(WorkflowContext);
  if (!context) {
    throw new Error("useWorkflow must be used within a WorkflowProvider");
  }
  return context;
};
